// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"5a0bc764","513":"30befd4f","703":"b0a10098"}[chunkId] + ".chunk.js";
};